
import {Component, Mixins, Prop} from "vue-property-decorator";
import {IAvukatTalepAdresTuru} from "@/plugins/uyap-plugin/uyap/GetPortalAvukatTalepAdresTuruList";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

export enum AvukatTalepAdresTuru{
  E_TEBLIGAT = 0,
  MERNIS = 1,
  MERSIS= 2,
  YENI = 3,
  VEKILIN_E_TEBLIGAT = 4
}

@Component({
  components: {}
})

export default class AvukatTalepAdresTuruPicker extends Mixins(SimpleInputMixin) {
  @Prop() rules!: string;
  @Prop() showUyapIcon!: string | boolean;
  @Prop() tooltip!: string;
  @Prop() kisiMi!: boolean | undefined;

  items: Array<IAvukatTalepAdresTuru> = [];

  get isShowUyapIcon() {
    return this.showUyapIcon || this.showUyapIcon === "";
  }

  onAdresTuruChange(v: IAvukatTalepAdresTuru) {
    this.$emit('adresTuruAciklama', (this.items.find(item => item.value == this.localValue))?.name);
    this.input();
  }

  created() {
    this.load();
  }

  async load() {
    let items = (await this.$uyap.GetPortalAvukatTalepAdresTuruList().run({}));
    items.forEach((item, index) => {
      if (this.kisiMi === true && item.value == AvukatTalepAdresTuru.MERSIS) {
        this.items.slice(index, 1)
      }
      if (this.kisiMi === false && item.value == AvukatTalepAdresTuru.MERNIS) {
        this.items.slice(index, 1)
      }
    })
    this.items = items.filter((item) => {
      if (this.kisiMi === true)
        return item.value != AvukatTalepAdresTuru.MERSIS;
      else if (this.kisiMi === false)
        return item.value != AvukatTalepAdresTuru.MERNIS;
      else
        return true;
    });
  }
}
